export enum ProjectType {
  ProfileSurvey = 1,
  Research = 2,
  DynamicProfile = 3
}
